import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import {
  useAmplitude,
  useAsideState,
  useUserInfo,
} from "../../../hooks";
import { TYPE, URL } from "../../../constant";
import useHackleInfo from "../../../hooks/useHackle";
import HACKLE_DATA from "../../../constant/HACKLE_DATA";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";
import { checkPayPopup } from "../../../utils/utilityEtc";

const PayPopup3 = () => {
  const { setAsideState } = useAsideState();
  const location = useLocation();
  const [isShowPopup, setIsShowPopup] = useState(false);

  const history = useHistory();
  const {
    t,
  } = useTranslation();
  const { info } = useUserInfo();
  const { setHackleLog } = useHackleInfo();
  const { setAmplitudeLog } = useAmplitude();

  const handlePage = useCallback(() => {
    // 결제팝업버튼 클릭
    setAmplitudeLog({ eventCategory: 'payment', eventName: '결제팝업버튼 클릭' });
    setHackleLog(HACKLE_DATA.TYPE.POP_WELCOME_BTN_CLICK);
    appsflyer({
      eventName: appsflyerEventName.purchase_pop_btn_click,
      eventParams: null,
    });

    if(info?.countryCd === TYPE.COUNTRY_CODE.KOREA) {
      // KR
      history.push(URL.PAYMENT.SUBSCRIBE);
    } else {
      // IN or PH
      history.push(URL.PAYMENT.SUBSCRIBE_NEW);
    }

    hidePopup();
  }, [info]);

  const handleCloseBtn = useCallback(() => {
    setIsShowPopup(false);
    hidePopup();
  }, []);

  const hidePopup = useCallback(() => {
    // gb_view_count 로컬스토리지 변경
    const gbViewCountObj = JSON.parse(localStorage.getItem("gb_view_count"));
    const gbView = gbViewCountObj?.[URL.SELECT_LEARNING];

    if (gbView) {
      localStorage.setItem(
        "gb_view_count",
        JSON.stringify({
          ...gbViewCountObj,
          [URL.SELECT_LEARNING]: {
            ...gbView,
            count: gbView.count,
            isShowPopup: !gbView.isShowPopup,
          },
        })
      );
    }
  }, []);

  useEffect(() => {
    if (location.state?.prevPoint === "appLogin") {
      setIsShowPopup(checkPayPopup(URL.SELECT_LEARNING));
    }
  }, [location]);

  return (
    // 주제학습 팝업
    isShowPopup ? (
      <div className="pay_popup btm">
        <div className="lp-wrap lp-middle lp_btmidle">
          <div className="lc-alert lc-def">
            <img
              className="logo_mathpid"
              src={`${process.env.PUBLIC_URL}/static/images/payment/logo_mathpid.svg`}
              alt="mathpid premium"
            />
            <p
              className="bnr_tit"
              dangerouslySetInnerHTML={{
                __html: t("PAYMENT.PAY_POPUP_3.msg001"),
              }}
            />
            <p
              className="bnr_txt"
              dangerouslySetInnerHTML={{
                __html: t("PAYMENT.PAY_POPUP_3.msg002"),
              }}
            />
            {/* <div className="pay_sum">
              {info?.countryCd === TYPE.COUNTRY_CODE.KOREA && (
                <Fragment>
                  <span className="sum">
                    {t(
                      `PAYMENT.PAY_POPUP_3.msg003_${
                        info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID
                          ? "KR"
                          : "IN"
                      }`
                    )}
                  </span>
                  <span className="year">
                    {t(
                      `PAYMENT.PAY_POPUP_3.msg004_${
                        info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID
                          ? "KR"
                          : "IN"
                      }`
                    )}
                  </span>
                </Fragment>
              )} */}
              {/* {info?.countryCd === TYPE.COUNTRY_CODE.INDIA && (
                <Fragment>
                  <span className="sum">₹1550</span>
                  <span className="year"> ₹309.99 / per Year</span>
                </Fragment>
              )}
              {info?.countryCd === TYPE.COUNTRY_CODE.PHILIPPINES && (
                <Fragment>
                  <span className="sum">₱1050</span>
                  <span className="year"> ₱209.99 / per Year</span>
                </Fragment>
              )} */}
            {/* </div> */}
            <div className="lp-btnBox">
              <button
                type="button"
                className="btn btn-blue"
                onClick={handlePage}
              >
                {t("PAYMENT.PAY_POPUP_3.msg005")}
              </button>
            </div>
            <button
              type="button"
              className="btn_exit close"
              onClick={handleCloseBtn}
            >
              {t("PAYMENT.PAY_POPUP_3.msg006")}
            </button>
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  );
};

export default PayPopup3;
